module.exports = __webpack_public_path__ + "static/media/exit.bb8b50c1.svg";